import React from 'react';

const NotFoundPage = () => {
  return (
    <div className="d-flex align-items-center justify-content-center vh-100 bg-light text-center">
      <div className="p-5 bg-white rounded shadow">
        <h1 className="display-1 text-danger">404</h1>
        <p className="lead text-dark mb-4">Oops! Page not found.</p>
      </div>
    </div>
  );
};

export default NotFoundPage;
